export const landingUrl = process.env.REACT_APP_CODEPLATFORM_LANDING_URL
